import React from "react";

export default function Footer() {
  return (
    <section className="footer3 cid-s48P1Icc8J" id="footer3-i">
      <div className="container">
        <div className="media-container-row align-center mbr-white">
          <div className="row row-links">
            <ul className="foot-menu">
              <li className="foot-menu-item mbr-fonts-style display-7">
                <a href={"/"} className="text-success">
                  Help Center
                </a>
              </li>
              <li className="foot-menu-item mbr-fonts-style display-7">
                <a href={"/"} className="text-success">
                  Forums
                </a>
              </li>
              <li className="foot-menu-item mbr-fonts-style display-7">
                <a href={"/"} className="text-success">
                  #
                </a>
              </li>
            </ul>
          </div>
          <div className="row social-row">
            <div className="social-list align-right pb-2">
              <div className="soc-item">
                <a href={"/"}>
                  <span className="socicon-twitter socicon mbr-iconfont mbr-iconfont-social"></span>
                </a>
              </div>
              <div className="soc-item">
                <a href={"/"}>
                  <span className="socicon-facebook socicon mbr-iconfont mbr-iconfont-social"></span>
                </a>
              </div>
              <div className="soc-item">
                <a href={"/"}>
                  <span className="socicon-youtube socicon mbr-iconfont mbr-iconfont-social"></span>
                </a>
              </div>
              <div className="soc-item">
                <a href={"/"}>
                  <span className="mbr-iconfont mbr-iconfont-social socicon-instagram socicon"></span>
                </a>
              </div>
            </div>
          </div>
          <div className="row row-copirayt">
            <p className="mbr-text mb-0 mbr-fonts-style mbr-white align-center display-7">
              © Copyright 2020 Ameer-Ali. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
